// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardTopNav_bar__SJY4N {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.86);
  border-bottom: 1px solid var(--border);
  backdrop-filter: saturate(180%) blur(12px);
  -webkit-backdrop-filter: saturate(180%) blur(12px);
}

@supports not (backdrop-filter: blur(12px)) {
  .DashboardTopNav_bar__SJY4N {
    background: var(--bg);
  }
}

.DashboardTopNav_inner__D0stS {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 var(--gutter);
  height: 54px;
  display: flex;
  align-items: center;
  gap: var(--space-4);
}

.DashboardTopNav_brand__IFmIu {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  text-decoration: none;
  color: var(--primary);
  font-weight: 700;
  flex-shrink: 0;
}

.DashboardTopNav_brandText__8ZvbU {
  font-size: 1.0625rem;
  letter-spacing: -0.018em;
}

.DashboardTopNav_badge__ZXJjj {
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 2px 7px;
  border-radius: var(--radius-xs);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  margin-left: var(--space-1);
}

.DashboardTopNav_nav__RB5pf {
  display: flex;
  align-items: center;
  gap: 2px;
  flex: 1 1;
  overflow-x: auto;
  scrollbar-width: none;
}

.DashboardTopNav_nav__RB5pf::-webkit-scrollbar {
  display: none;
}

.DashboardTopNav_link__Q2Lh4 {
  padding: 6px 11px;
  border-radius: var(--radius-sm);
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-decoration: none;
  white-space: nowrap;
  transition:
    color var(--dur-fast) var(--ease-standard),
    background-color var(--dur-fast) var(--ease-standard);
}

.DashboardTopNav_link__Q2Lh4:hover {
  color: var(--text-primary);
  background: var(--bg-secondary);
}

.DashboardTopNav_linkActive__P7vbB {
  color: var(--primary);
  background: var(--surface-brand-wash);
}

.DashboardTopNav_right__Y9gWM {
  flex-shrink: 0;
}

.DashboardTopNav_mainSite__hMsPf {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--primary);
  text-decoration: none;
  padding: 6px 11px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--surface-selected);
  transition: background-color var(--dur-fast) var(--ease-standard);
}

.DashboardTopNav_mainSite__hMsPf:hover {
  background: var(--surface-brand-wash);
}

@media (max-width: 640px) {
  .DashboardTopNav_brandText__8ZvbU {
    display: none;
  }

  /* Tabs drop to their own full-width row so none get clipped. */
  .DashboardTopNav_inner__D0stS {
    height: auto;
    min-height: 50px;
    flex-wrap: wrap;
    row-gap: 0;
    column-gap: var(--space-2);
    padding-top: 6px;
  }

  .DashboardTopNav_right__Y9gWM {
    margin-left: auto;
  }

  .DashboardTopNav_nav__RB5pf {
    order: 3;
    flex: 1 1 100%;
    margin: 0 calc(-1 * var(--gutter));
    padding: 4px var(--gutter) 6px;
  }

  .DashboardTopNav_link__Q2Lh4 {
    padding: 5px 10px;
    font-size: 0.875rem;
  }

  .DashboardTopNav_mainSite__hMsPf {
    font-size: 0.8125rem;
    padding: 5px 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DashBoard/DashboardTopNav.module.css"],"names":[],"mappings":"AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB;;yDAEuD;AACzD;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,yCAAyC;EACzC,iEAAiE;AACnE;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA,+DAA+D;EAC/D;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,cAAc;IACd,kCAAkC;IAClC,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;AACF","sourcesContent":["@import url(\"../../colors.css\");\n\n.bar {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: rgba(255, 255, 255, 0.86);\n  border-bottom: 1px solid var(--border);\n  backdrop-filter: saturate(180%) blur(12px);\n  -webkit-backdrop-filter: saturate(180%) blur(12px);\n}\n\n@supports not (backdrop-filter: blur(12px)) {\n  .bar {\n    background: var(--bg);\n  }\n}\n\n.inner {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 var(--gutter);\n  height: 54px;\n  display: flex;\n  align-items: center;\n  gap: var(--space-4);\n}\n\n.brand {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  text-decoration: none;\n  color: var(--primary);\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.brandText {\n  font-size: 1.0625rem;\n  letter-spacing: -0.018em;\n}\n\n.badge {\n  font-size: 0.6875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding: 2px 7px;\n  border-radius: var(--radius-xs);\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  margin-left: var(--space-1);\n}\n\n.nav {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex: 1;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.nav::-webkit-scrollbar {\n  display: none;\n}\n\n.link {\n  padding: 6px 11px;\n  border-radius: var(--radius-sm);\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-decoration: none;\n  white-space: nowrap;\n  transition:\n    color var(--dur-fast) var(--ease-standard),\n    background-color var(--dur-fast) var(--ease-standard);\n}\n\n.link:hover {\n  color: var(--text-primary);\n  background: var(--bg-secondary);\n}\n\n.linkActive {\n  color: var(--primary);\n  background: var(--surface-brand-wash);\n}\n\n.right {\n  flex-shrink: 0;\n}\n\n.mainSite {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--primary);\n  text-decoration: none;\n  padding: 6px 11px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--surface-selected);\n  transition: background-color var(--dur-fast) var(--ease-standard);\n}\n\n.mainSite:hover {\n  background: var(--surface-brand-wash);\n}\n\n@media (max-width: 640px) {\n  .brandText {\n    display: none;\n  }\n\n  /* Tabs drop to their own full-width row so none get clipped. */\n  .inner {\n    height: auto;\n    min-height: 50px;\n    flex-wrap: wrap;\n    row-gap: 0;\n    column-gap: var(--space-2);\n    padding-top: 6px;\n  }\n\n  .right {\n    margin-left: auto;\n  }\n\n  .nav {\n    order: 3;\n    flex: 1 1 100%;\n    margin: 0 calc(-1 * var(--gutter));\n    padding: 4px var(--gutter) 6px;\n  }\n\n  .link {\n    padding: 5px 10px;\n    font-size: 0.875rem;\n  }\n\n  .mainSite {\n    font-size: 0.8125rem;\n    padding: 5px 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bar": `DashboardTopNav_bar__SJY4N`,
	"inner": `DashboardTopNav_inner__D0stS`,
	"brand": `DashboardTopNav_brand__IFmIu`,
	"brandText": `DashboardTopNav_brandText__8ZvbU`,
	"badge": `DashboardTopNav_badge__ZXJjj`,
	"nav": `DashboardTopNav_nav__RB5pf`,
	"link": `DashboardTopNav_link__Q2Lh4`,
	"linkActive": `DashboardTopNav_linkActive__P7vbB`,
	"right": `DashboardTopNav_right__Y9gWM`,
	"mainSite": `DashboardTopNav_mainSite__hMsPf`
};
export default ___CSS_LOADER_EXPORT___;
